import React, { useState } from "react";
import {
    Box,
    Container,
    TextField,
    Button,
    Grid,
    Typography,
    makeStyles,
} from "@material-ui/core";
import Header from "../../components/Headers/Header";
import componentStyles from "../../assets/theme/views/admin/tables.js";
import { BACKEND_URL } from "../../env.js";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    ...componentStyles,
    formContainer: {
        backgroundColor: "#fff",
        padding: theme.spacing(4),
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: "800px",
    },
    inputField: {
        marginBottom: theme.spacing(2),
    },
}));

function CreateOrder() {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        profileMargin: "0",
        address1: "",
        country: "UAE",
        city: "",
        totalAmount: "",
        products: "",
        view: "subadmin",
        quantity: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        console.log("Order Created:", formData);
        // Add your API call here
        setIsLoading(true);
        try {
            const response = await fetch(`${BACKEND_URL}/orders/CreateSubAdminOrder`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem("Token"),
                },
                body: JSON.stringify({
                    ...formData,
                    products: [{
                        productId: formData.products,
                        quantity: formData.quantity, // Assuming quantity is 1 for simplicity
                    }]
                }),
            });
            if (response.ok) {
                const result = await response.json();
                console.log(result);
                toast.success("Order created successfully!");
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phoneNumber: "",
                    profileMargin: "",
                    address1: "",
                    country: "UAE",
                    city: "",
                    totalAmount: "",
                    products: "",
                    quantity: "",
                    view: "subadmin",
                });

            }
        } catch (error) {
            console.error("Error creating order:", error);
            toast.error("Failed to create order. Please try again.");
        } finally {
            setIsLoading(false);
        }

    };

    return (
        <>
            <Header />
            <Container
                maxWidth={false}
                component={Box}
                // marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    minHeight="100vh"
                >
                    <Box className={classes.formContainer}>
                        <Typography variant="h4" gutterBottom>
                            Create Order
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="First Name"
                                    name="firstName"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Last Name"
                                    name="lastName"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Email"
                                    name="email"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.email}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Phone Number"
                                    name="phoneNumber"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Profit Margin"
                                    name="profileMargin"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.profileMargin}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <TextField
                                    label="Address"
                                    name="address1"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.address1}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Country"
                                    name="country"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.country}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                    disabled={true} // Assuming country is always UAE
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="City"
                                    name="city"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.city}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Total Amount"
                                    name="totalAmount"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.totalAmount}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Products"
                                    name="products"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.products}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Quantity"
                                    name="quantity"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.quantity}
                                    onChange={handleChange}
                                    className={classes.inputField}
                                />
                            </Grid>
                        </Grid>
                        <Box mt={3} textAlign="center">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? "Submitting..." : "Submit Order"}
                                {/* Submit Order */}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </>
    );
}

export default CreateOrder;
